export const AppStep = {
  Designs: 'designs',
  Style: 'brand-style',
  Colors: 'colors',
  Brief: 'brief',
  Thanks: 'thanks'
}
